<template>
  <view-toolbox
    back-title="page"
    title="Map Menu"
  >
    <div>
      <toc-links :items="items" />
    </div>
  </view-toolbox>
</template>

<script>
import ViewToolbox from '@/components/views/ViewToolbox';
import TocLinks from '@/components/views/TocLinks';
import ViewUtils from '@/components/views/ViewUtils';

export default {
  name: 'MapTOC',
  components: {
    ViewToolbox,
    TocLinks,
  },
  mixins: [
    ViewUtils,
  ],
  computed: {
    items() {
      return [
        {
          title: 'Source',
          copy: 'which records to display',
          link: 'source',
          filters: this.activeView?.hasSourceFilters?.(),
        },
        {
          title: 'Map Settings',
          copy: 'options and settings',
          link: 'settings',
        },
        {
          title: 'Location Details',
          copy: 'add fields and links',
          link: 'list',
        },
      ];
    },
  },
};
</script>
